import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EChartsCore = _resolveComponent("EChartsCore")!
  const _component_EChartsBase = _resolveComponent("EChartsBase")!
  const _component_EChartsScrollContainer = _resolveComponent("EChartsScrollContainer")!

  return (_openBlock(), _createBlock(_component_EChartsScrollContainer, {
    class: "echarts-vertical-bar",
    minWidth: _ctx.minWidth
  }, {
    default: _withCtx(() => [
      _createVNode(_component_EChartsBase, {
        isEmpty: _ctx.getIsEmpty,
        emptyMessage: _ctx.emptyMessage,
        height: _ctx.height,
        titleConfig: _ctx.titleConfig
      }, {
        default: _withCtx(() => [
          _createVNode(_component_EChartsCore, {
            ref: "chartRef",
            option: _ctx.getChartOption,
            autoresize: "",
            loading: _ctx.isLoading,
            loadingOptions: _ctx.getLoadingOptions
          }, null, 8, ["option", "loading", "loadingOptions"])
        ]),
        _: 1
      }, 8, ["isEmpty", "emptyMessage", "height", "titleConfig"])
    ]),
    _: 1
  }, 8, ["minWidth"]))
}